<template>
  <button
    data-testid="button-next"
    :class="[
      style.nextButton,
      withoutMargin ? style.withoutMargin : '',
      isLongButton ? style.longButton : '',
      isPurple ? style.onlyPurple : '',
      fakeAfter || isSuccessAndNotSend || isLastQuestionAndNotError
        ? style.flare
        : '',
      isErrorSendForm ? style.errorButton : '',
      !onlyFormBool && !isErrorSendForm && isGreeting ? style.quizButton : '',
      onlyFormBool && isFormSend && !isErrorSendForm ? style.onlyPurple : '',
      isLastQuestionAndNotError ? style.thanksButton : '',
      !isLastQuestion && !isGreeting ? style.continueStyle : '',
      simple ? style.simpleButton : ''
    ]"
    :style="styleButton"
  >
    <span
      :class="style.textButton"
      v-if="ifText"
      v-text="text"
      :style="styleText ?? {}"
    />
    <LoaderTextButton v-else-if="isFormSend && !isErrorSendForm" />
    <span v-else-if="elseIfText">{{
      alternativeText ? alternativeText : "Получить расчёт"
    }}</span>
    <span
      :class="style.fakeAfter"
      v-if="
        fakeAfter ||
        (isLastQuestion && isSuccessAndNotSend) ||
        (!simple && !(!isLastQuestion && !isGreeting))
      "
    />
    <span v-if="isErrorSendForm" :style="{color: 'white'}">Ошибка</span>
  </button>
</template>

<script lang="ts">
import style from "./ButtonComponent.module.scss";
import LoaderTextButton from "@/elements/loaderTextButton/LoaderTextButton.vue";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";
import {defineComponent} from "vue";

export default defineComponent({
  name: "ButtonComponent",
  components: {LoaderTextButton},
  props: {
    text: String,
    fakeAfter: {
      type: Boolean,
      default: true
    },
    styleButton: Object,
    styleText: Object,
    isLongButton: Boolean,
    isPurple: {
      type: Boolean,
      default: false
    },
    isErrorSendForm: Boolean,
    isSuccessAndNotSend: Boolean,
    isFormSend: Boolean,
    isLastQuestionAndNotError: Boolean,
    ifText: {
      type: Boolean,
      default: true
    },
    elseIfText: Boolean,
    withoutMargin: Boolean,
    isLastQuestion: Boolean,
    alternativeText: String,
    isGreeting: {
      type: Boolean,
      default: true
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style,
      modifyQuiz
    };
  },
  methods: {},
  computed: {
    onlyFormBool() {
      return this.modifyQuiz("get", "", ["onlyFormBool"]);
    }
  }
});
</script>
